import axios from 'axios'

// create an axios instance
const service = axios.create({
  baseURL: process.env.BASE_API, // api base_url
  timeout: 60000 // request timeout,
})

// request interceptor
service.interceptors.request.use(config => {
  // console.log('interceptors store.getters.token:', store.getters.token)
  // Do something before request is sent
  // console.log(`[request.js] config =>`, config) // for debug
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// response interceptor
service.interceptors.response.use(
  response => {
    return response
  },
  error => {
    console.error('**************************')
    console.error('[request.js] error:', error) // for debug
    console.log('[request.js] error:', JSON.stringify(error))
    return Promise.reject((error.response) ? error.response : error.message)
  })

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js